import { useConfigStore } from '../../store/config-store.js';
import { Button } from '../ui/Button.js';
import { Upload, CheckCircle2 } from 'lucide-react';

export function PushBar(): JSX.Element {
  const diff = useConfigStore((s) => s.diff);
  const push = useConfigStore((s) => s.push);
  const pushing = useConfigStore((s) => s.pushing);

  const total = diff?.totalChanges ?? 0;
  const clean = total === 0;

  return (
    <footer className="h-12 shrink-0 border-t border-border bg-surface px-5 flex items-center justify-between">
      <div className="flex items-center gap-3 text-sm">
        {clean ? (
          <span className="flex items-center gap-2 text-text-dim">
            <CheckCircle2 size={14} className="text-ok" />
            Live-System aktuell
          </span>
        ) : (
          <>
            <span className="inline-flex items-center px-2 h-5 rounded-btn bg-warn/15 text-warn text-xxs font-semibold uppercase tracking-wider">
              Draft
            </span>
            <span className="text-text-dim">
              <span className="text-text font-semibold">{total}</span>{' '}
              {total === 1 ? 'Änderung' : 'Änderungen'} ausstehend
            </span>
            {diff ? <DiffSummary diff={diff} /> : null}
          </>
        )}
      </div>

      <Button
        variant="primary"
        size="sm"
        disabled={clean || pushing}
        onClick={() => void push()}
        leftIcon={<Upload size={14} />}
      >
        {pushing ? 'Pushe…' : 'Zum Live-System pushen'}
      </Button>
    </footer>
  );
}

function DiffSummary({
  diff,
}: {
  diff: NonNullable<ReturnType<typeof useConfigStore.getState>['diff']>;
}): JSX.Element {
  const parts: string[] = [];
  if (diff.panelsAdded || diff.panelsRemoved || diff.panelsChanged) {
    parts.push(
      `Panels +${diff.panelsAdded}/-${diff.panelsRemoved}/~${diff.panelsChanged}`,
    );
  }
  if (diff.buttonsAdded || diff.buttonsRemoved || diff.buttonsChanged) {
    parts.push(
      `Buttons +${diff.buttonsAdded}/-${diff.buttonsRemoved}/~${diff.buttonsChanged}`,
    );
  }
  if (diff.partylinesAdded || diff.partylinesRemoved || diff.partylinesChanged) {
    parts.push(
      `Partylines +${diff.partylinesAdded}/-${diff.partylinesRemoved}/~${diff.partylinesChanged}`,
    );
  }
  if (parts.length === 0) return <></>;
  return <span className="text-xxs text-text-mute">({parts.join(' · ')})</span>;
}
